export const ShareableResourceType = {
    TradingStrategy: 'tradingStrategy',
    OptionBuyingStrategy: 'optionBuyingStrategy',
    TradingProfile: 'tradingProfile',
    Scorecard: 'scorecard'
};
export const ResourcePrincipalType = {
    User: 'user',
    Team: 'team'
};
export const ResourceGrantRole = {
    Viewer: 'viewer',
    Consumer: 'consumer',
    Copier: 'copier',
    Editor: 'editor'
};
export const ResourceGrantSourceType = {
    Direct: 'direct',
    Inherited: 'inherited'
};
export const ResourcePublicationAudienceType = {
    AllUsers: 'allUsers',
    Team: 'team'
};
export const ResourcePublicationListingStatus = {
    Listed: 'listed',
    Unlisted: 'unlisted',
    Withdrawn: 'withdrawn'
};
export const ResourceAccessEventType = {
    Grant: 'grant',
    Revoke: 'revoke',
    Publish: 'publish',
    Withdraw: 'withdraw',
    Version: 'version',
    Transfer: 'transfer'
};
//# sourceMappingURL=ResourceAccessTypes.js.map